import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { colorTextMuted } from "src/design/tokens";
import { AccountRequest } from "src/data/admin/queries/accountRequest";
import { AccountRequestRow } from "./AccountRequestRow";

interface AccountRequestsTableProps {
  requests: AccountRequest[];
  onApprove: (request: AccountRequest) => void;
  onReject: (request: AccountRequest) => void;
}

export const AccountRequestsTable = ({
  requests,
  onApprove,
  onReject,
}: AccountRequestsTableProps) => {
  if (requests.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body2" sx={{ color: colorTextMuted }}>
          No account requests yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ overflowX: "auto" }}>
      <Table size="small" sx={{ mt: -1, minWidth: 800 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600, pl: 0 }}>
              Name
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Email
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Phone
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Restaurant
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              City
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Plan
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Status
            </TableCell>
            <TableCell sx={{ color: colorTextMuted, fontWeight: 600 }}>
              Created
            </TableCell>
            <TableCell
              align="right"
              sx={{ color: colorTextMuted, fontWeight: 600, pr: 0 }}
            >
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((req) => (
            <AccountRequestRow
              key={req.id}
              request={req}
              onApprove={onApprove}
              onReject={onReject}
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
